export default "__VITE_ASSET__Dcbrsd5y__"